// Import mutations
import { GET_CONTENTS } from '../mutation-types'

const state = { all: [] }

const mutations = {
  [GET_CONTENTS] (state, contents) {
    state.all = contents
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/contents.js